module.exports = __webpack_public_path__ + "PT.png?3b9620004a404307632241fdd297ad8b";